import { E_ProcessEnv, getAppEnv, getProcessEnv, isNodeProd } from './base/env'
import getURLSearchParam, { toUrlParams } from './base/url'
import { APP_ENV } from './consts'
import { reportError } from './owl'

const iProjectName = getProcessEnv(E_ProcessEnv.VUE_APP_PROJECT_NAME)

const SUB_PATH_MAP: Record<string, string> = {
  'i.meituan.com': '/awp/ia/i-zhenguo-activity',
  'icrm.ia.test.sankuai.com': '/external',
  'icrm.ia.st.sankuai.com': '/external',
  'icrm-guo.meituan.com': '/external',
}

export function genBaseUrl(projectName = iProjectName, origin = window.location.origin) {
  if (origin === 'https://h5-zhenguo.meituan.com') {
    origin = 'https://i.meituan.com'
  }
  if (!isNodeProd()) {
    if (projectName === iProjectName) {
      // 开发环境，当前页面
      return origin
    }
    let host = 'i.meituan.com'
    try {
      host = new URL(getProcessEnv(E_ProcessEnv.VUE_APP_DOMAIN_ACTIVITY) || '').host
    } catch (err) {
      reportError({
        name: 'VUE_APP_DOMAIN_ACTIVITY 未定义',
      })
    }
    const subPath = Object.prototype.hasOwnProperty.call(SUB_PATH_MAP, host)
      ? SUB_PATH_MAP[host]
      : '/ia/i-zhenguo-activity'
    // 开发环境，其它页面
    return getProcessEnv(E_ProcessEnv.VUE_APP_DOMAIN_ACTIVITY) + subPath + '/' + projectName
  }
  if (getProcessEnv(E_ProcessEnv.VUE_APP_DEPLOY_ENV) === 'newtest') {
    // 发布环境，测试环境
    return origin + '/' + projectName
  }
  const host = new URL(origin).host
  const subPath = Object.prototype.hasOwnProperty.call(SUB_PATH_MAP, host)
    ? SUB_PATH_MAP[host]
    : '/ia/i-zhenguo-activity'
  // 发布环境，其它
  return origin + subPath + '/' + projectName
}

export function genActUrl(filename = 'index', params?: {}, randomParamStr?: string) {
  return genOtherActUrl(iProjectName, filename, params, randomParamStr)
}

export function genOtherActUrl(projectName = iProjectName, filename = 'index', params?: {}, randomParamStr?: string) {
  if (projectName === iProjectName) {
    const filenames = getProcessEnv(E_ProcessEnv.VUE_APP_FILENAMES) || ['index']
    if (filenames.indexOf(filename + '.html') === -1) {
      reportError &&
        reportError({
          name: '跳转地址有问题',
          msg: filename,
        })
      return genBaseUrl(projectName) + '/index.html'
    }
  }
  let baseUrl = genBaseUrl(projectName) + '/' + filename + '.html'
  if (getAppEnv() === APP_ENV.production && randomParamStr) {
    baseUrl = `https://h5-zhenguo.meituan.com/awp_${projectName}_${filename}/${btoa(
      new Date().toISOString(),
    )}-${randomParamStr}`
  }
  let queryStr = params instanceof URLSearchParams ? params.toString() : toUrlParams(params)
  ;['liteset', 'swimlane', 'phx_env', 'uuid'].forEach((key) => {
    if (getURLSearchParam(key)) {
      queryStr += (queryStr ? '&' : '') + key + '=' + getURLSearchParam(key)
    }
  })
  return baseUrl + (queryStr ? '?' + queryStr : '')
}
